module.exports = __webpack_public_path__ + "static/media/head_tug.c9861f73.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/head_tug.png
// module id = 1640
// module chunks = 1